// extracted by mini-css-extract-plugin
module.exports = {"container":"textarea_container_2okdQ","chars":"textarea_chars_24hBu"};